import { INIT_OCURRENCES_DAILY } from '../../actions/f5-actions/action-types';

const INIT_STATE = {};

export default (state = INIT_STATE, action) => {
  switch (action.type) {
    case INIT_OCURRENCES_DAILY: {
      return { ...state, data: action.data };
    }
    default:
      return state;
  }
};
